export default {"src":"/_next/static/media/trendDown.595b26f2.svg","height":25,"width":24};